import { type ReactElement } from 'react';

import { type ApiMediaUploadSettings, type FieldSettings, type FieldValue } from '~modules/jsm-contact/shared/types';
import { createFormField } from './ComponentFactory';

type FieldGroupProps = {
  fieldSettings: FieldSettings;
  fieldValue: FieldValue | FieldValue[];
  error?: string | null;
  onValueChanged: (key: string, value: FieldValue | FieldValue[]) => void;
  onError: () => void;
  isSubmitting: boolean;
  dataKey: string;
  apiMediaUploadSettings?: ApiMediaUploadSettings;
};

export function FieldGroup({
  fieldSettings,
  fieldValue,
  onValueChanged,
  error,
  onError,
  isSubmitting,
  dataKey,
  apiMediaUploadSettings,
}: FieldGroupProps): ReactElement | null {
  const field = createFormField({
    fieldSettings,
    fieldValue,
    onValueChanged,
    error,
    onError,
    isSubmitting,
    dataKey,
    apiMediaUploadSettings,
  });
  if (!field) {
    return null;
  }

  const errorMessage = () => {
    if (error !== null) {
      return <div className="error c-hint--error text-sm">{error}</div>;
    }
    return null;
  };

  return (
    <div className="c-form-element py-sm-0">
      <label htmlFor={fieldSettings.name} className="u-margin-top-md u-margin-bottom-negative-md c-label">
        {fieldSettings.label}
        {fieldSettings.required && <span className="c-hint--error">*</span>}
      </label>
      {field}
      {errorMessage()}{' '}
    </div>
  );
}
